<template>
  <section class="container">
    <div class="card">
      <div class="card-image" />
      <div class="card-title">
        Protect your account with
        <br />2-Step Verification
      </div>
      <div class="card-content">
        <span>
          Each time you sign in to your Arduino account, you’ll need your
          <strong>password</strong> and a
          <strong>verification code</strong> that’s sent to your phone: this will assure that even if someone else gets your password, they won’t be able to sign in to your account.
        </span>
      </div>
      <div class="card-actions">
        <button class="store-button secondary" v-on:click="continueLogin">Skip</button>
        <button class="store-button" v-on:click="startEnroll">get started</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Reminder',
  props: ['state'],
  methods: {
    continueLogin() {
      if (this.state) {
        window.location.replace(`https://${process.env.VUE_APP_AUTH0_DOMAIN}/continue?state=${this.state}`);
      } else {
        window.location.replace(process.env.VUE_APP_ID_PROFILE_URL);
      }
    },
    startEnroll() {
      if (this.state) {
        this.$router.push({
          name: 'enroll',
          query: { state: this.state }
        });
      } else {
        this.$router.push({
          name: 'enroll'
        });
      }
    }
  }
};
</script>

<style lang="scss">
.card-image {
  background-image: url("../assets/reminder.svg");
}
</style>
